// ------------------
// Imports
// ------------------

import Vue from 'vue'
import Config from '@/common/configs/popups'



// ------------------
// Defaults
// ------------------

const defaults = {
    clearable: true
};



// ------------------
// Helpers
// ------------------

function display (value) {
    return {
        display: value ? '' : 'none'
    }
}



// ------------------
// State
// ------------------

const State = Vue.observable({
    opened: [],
    active: -1
});



// ------------------
// Popup
// ------------------


const Popup = {

    show (key, props, opts) {
        return new Promise(resolve => {
            const popup = {key, props, options: {...defaults, ...opts}, resolve};
            State.active = State.opened.push(popup) - 1;
        })
    },

    hide (param, index = State.opened.length - 1) {
        param !== undefined && State.opened[index].resolve(param);
        State.opened.splice(index, 1);
        State.active = State.opened.length - 1;
    },

    clear () {
        const cleared = State.opened.filter(popup => !popup.options.clearable);
        State.active = cleared.length - 1;
        State.opened = cleared;
    }

};


// readonly properties

Object.defineProperty(Popup, 'isActive', {
    get () {
        return State.active !== -1;
    }
});



// ------------------
// Plugin
// ------------------

Vue.use({

    install () {


        // set actions globally

        Vue.prototype.$popup = Popup;


        // <popup-view> component

        Vue.component('popup-view', {

            props: {
                tag: {
                    type: String,
                    default: 'div'
                }
            },

            render (createElement) {
                return createElement(this.tag, {
                    style: display(Popup.isActive),
                }, State.opened.map((popup, index) => createElement(Config[popup.key], {
                    props: popup.props,
                    style: display(index === State.active)
                })));
            }

        });

    }

});



// ------------------
// Exports
// ------------------

export default Popup;
